import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import COLORS from '@styles/theme/colors';

export const Form = styled(Box)(({ theme }) => ({
  flex: 1,
  backgroundColor: COLORS.white,
  borderRadius: theme.spacing(1),
  boxShadow: '0px 82px 40px -14px rgba(100, 100, 100, 0.0784314)',
  padding: theme.spacing(5, 3),
  border: '1px solid #E0E0E0',

  '& .MuiButtonBase-root': {
    marginTop: theme.spacing(2)
  }
}));

export const FormItem = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  marginBottom: theme.spacing(3),

  '& .MuiInputLabel-root': {
    fontSize: 16,
    color: '#666666',
    marginBottom: theme.spacing(1)
  },

  '& .MuiOutlinedInput-root': {
    '&.Mui-focused': {
      '& .MuiOutlinedInput-notchedOutline': {
        borderWidth: 1
      }
    }
  }
}));

export const FormWrap = styled('div')({
  display: 'flex',
  flexDirection: 'column'
});

export const PasswordWrap = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  color: '#666666',
  cursor: 'pointer',

  '& .show-password': {
    display: 'flex',
    alignItems: 'center',

    '& svg': {
      marginRight: 7
    }
  }
});

export const Title = styled('h1')(({ theme }) => ({
  ...theme.typography.h1,
  textAlign: 'center',
  marginBottom: theme.spacing(3.5),
  marginTop: 0
}));

export const Header = styled('div')(({ theme }) => ({
  padding: theme.spacing(3.5, 0)
}));

export const ImgWrap = styled('div')({
  flex: 1,

  '& img': {
    width: '100%',
    height: 'auto'
  }
});

export const Row = styled('div')({
  display: 'flex',
  margin: 'auto 0',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 40
});

export const Logo = styled('div')({});
